import { z } from "zod";

import { zMedia } from "@/lib/zod/show-fragments";
import type {
  SportsLeagueRef,
  SportsPlayerRef,
  SportsTeamRef,
} from "@/types/sports-refs";

/**
 * Lenient fragments shared by the sports child-document view schemas (standings,
 * match details, season stats). Same policy as `show-fragments.ts`: everything
 * nullish and `.passthrough()`, so a backend rename never blanks a page.
 */

/** Match-style team copy (backend MatchTeamDbDto): id, names, slug, crest, translations. */
export const zTeamRef: z.ZodType<SportsTeamRef> = z
  .object({
    id: z.string().nullish(),
    name: z.string().nullish(),
    shortName: z.string().nullish(),
    slug: z.string().nullish(),
    media: zMedia.nullish(),
    crestColor: z.string().nullish(),
  })
  .passthrough();

/** Match-style league copy (backend MatchLeagueDbDto). */
export const zLeagueRef: z.ZodType<SportsLeagueRef> = z
  .object({
    id: z.string().nullish(),
    name: z.string().nullish(),
    country: z.string().nullish(),
  })
  .passthrough();

/** A player named by the source only (backend SportsPlayerRefDbDto). */
export const zPlayerRef: z.ZodType<SportsPlayerRef> = z
  .object({
    providerId: z.string().nullish(),
    name: z.string().nullish(),
  })
  .passthrough();
